import Applestore from '../../assets/appstoreSmall_.png';
import Playstore from '../../assets/googleplaySmall_.png';

const DownloadAppBanner = () => {
    return (
        <div className='flex justify-center items-center fixed top-0 left-0 w-full h-[80px] bg-[#52FF00] z-50'>
            <div
                onClick={() =>
                    window.open(
                        'https://apps.apple.com/gb/app/player-the-footballers-app/id6503473876',
                        '_blank'
                    )
                }
                className='flex items-center mx-1 mt-3 cursor-pointer'
            >
                <img src={Applestore} alt='apple logo' className='w-[153px]' />
            </div>
            <div
                onClick={() =>
                    window.open(
                        'https://play.google.com/store/apps/details?id=com.playerapp.playerapp&pcampaignid=web_share',
                        '_blank'
                    )
                }
                className='flex items-center mx-1 mt-3 cursor-pointer'
            >
                <img src={Playstore} alt='google logo' className='w-[153px]' />
            </div>
        </div>
    );
};

export default DownloadAppBanner;
